
import { getAxiosInstance, requestConfig } from "../../http-common";

const RESOURCE_NAME = "analytics";

const get = (days: number) => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}?days=${days}`, requestConfig());
};

const AnalyticsService = {
    get
};
export default AnalyticsService;
